
export default () => ({
  openPayments: []
})
